import React from 'react';
import { useSelector } from 'react-redux';
import { StyleSheet, Image, View, SafeAreaView, TouchableOpacity, Linking } from 'react-native';
import { Color, CommonProperties, CommonStyles } from '../styles';
import BaseText from '../components/BaseText';
import { useTranslation } from 'react-i18next';
import { useComponentTKey } from '../i18n';
import Icon from '../components/Icon';
import { scale } from '../utils/scale.utils';
import { selectUserProfile } from '../store/selectors/profile.selector';
import { selectTezEvent } from '..//store/selectors/events.selector';
import { EVENTS_ENABLED } from '../config/env';

const AgentContactScreen = () => {
  const { t } = useTranslation();
  const { tKey } = useComponentTKey('AgentContactScreen');
  const companySupportDetails = useSelector(selectUserProfile);
  const eventMeetingDetails = useSelector(selectTezEvent);
  function IconButton({ url, name, text, type }) {
    let size = 60;
    if (type === 'mini') {
      size = 35;
    }
    return (
      <TouchableOpacity
        activeOpacity={0.5}
        onPress={() => {
          Linking.openURL(url);
        }}
      >
        <View style={CommonStyles.centerItems}>
          <Icon name={name} size={size} color={Color.primary} />
          {type != 'mini' && <BaseText style={styles.iconText}>{text}</BaseText>}
        </View>
      </TouchableOpacity>
    );
  }

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.wrap}>
        <Image style={styles.countryImage} source={require('../assets/images/us-flag.png')} />
        <BaseText style={styles.homeCountry}>{t(tKey('HomeCountry'))}</BaseText>
        <BaseText style={styles.country}>{t(tKey('UnitedStates'))}</BaseText>
      </View>
      <View style={styles.contact}>
        <IconButton
        url={
            EVENTS_ENABLED
              ? `tel:${eventMeetingDetails?.SupportContactNo}`
              : `tel:${companySupportDetails?.SupportContactNo}`
          }
          name={'phone'}
          text={t(tKey('Agent'))}
        />
        <IconButton
          url={
            EVENTS_ENABLED
              ? `mailto:${eventMeetingDetails?.SupportEmail}`
              : `mailto:${companySupportDetails?.SupportContactEmail}`
          }
          name={'message'}
          text={t(tKey('Message'))}
        />
      </View>
      <BaseText style={styles.desc}>{t(tKey('PhoneTiming'))}</BaseText>
      <View></View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  countryImage: {
    width: scale(100),
    height: scale(100),
    borderRadius: scale(50),
  },
  wrap: {
    justifyContent: 'space-around',
    alignItems: 'center',
    ...CommonProperties.py3,
  },
  contact: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    ...CommonProperties.py5,
  },
  homeCountry: {
    color: Color.text.medium,
    ...CommonProperties.mt4,
    ...CommonProperties.h4,
  },
  country: {
    color: Color.primary,
    ...CommonProperties.h2,
  },
  desc: {
    color: Color.text.medium,
    alignSelf: 'center',
    ...CommonProperties.p3,
  },
  iconText: {
    color: Color.primary,
    ...CommonProperties.mt3,
    ...CommonProperties.h3,
  },
});

export default AgentContactScreen;
